(function () {
  function initSection(section) {
    section.querySelectorAll('[data-compare-carousel]').forEach(function (carousel) {
      var id = carousel.id;
      var dotsWrap = section.querySelector('[data-carousel-dots-for="' + id + '"]');
      var dots = dotsWrap ? dotsWrap.querySelectorAll('button') : [];

      /* Mouse drag to scroll */
      var isDown = false;
      var startX = 0;
      var scrollStart = 0;
      var hasDragged = false;

      carousel.addEventListener('mousedown', function (e) {
        isDown = true;
        hasDragged = false;
        startX = e.pageX;
        scrollStart = carousel.scrollLeft;
        carousel.style.scrollSnapType = 'none';
        carousel.style.cursor = 'grabbing';
        e.preventDefault();
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 5) hasDragged = true;
        carousel.scrollLeft = scrollStart - dx;
      });

      document.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        carousel.style.cursor = '';
        carousel.style.scrollSnapType = 'x mandatory';
        var idx = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        carousel.scrollTo({ left: carousel.offsetWidth * idx, behavior: 'smooth' });
      });

      /* Block link navigation when dragging */
      carousel.addEventListener(
        'click',
        function (e) {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      /* Dot click → scroll */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.dataset.slide, 10);
          carousel.scrollTo({ left: carousel.offsetWidth * idx, behavior: 'smooth' });
        });
      });

      /* Scroll → active dot */
      var ticking = false;
      carousel.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var idx = Math.round(carousel.scrollLeft / carousel.offsetWidth);
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
          ticking = false;
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-compare-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
